module.exports = __webpack_public_path__ + "static/phone-carrier-sponsor-shirt-ce7d48580b0ae42fd366664499dec248.jpg";